/* eslint-disable react/prop-types */
import React from 'react'
import { Progress } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import SmallMilestoneIcon from '../common/SmallMilestoneIcon'
// import LargeMilestoneIcon from "../common/LargeMilestoneIcon";

import './DivisionPopover.scss'

const getColor = (div, record, target) => {
  if (record && record <= target) {
    switch (div) {
      case 1:
      case 6:
        return '#FF6633'
      case 2:
      case 7:
        return '#FDDB10'
      case 3:
      case 8:
        return '#D5DE27'
      case 4:
      case 9:
        return '#2BAAE1'
      case 5:
      case 10:
        return '#B51E8C'
      default:
        return '#414143'
    }
  } else {
    return '#f4f4f5'
  }
}

const getYardage = (div, t) => {
  switch (div) {
    case 1:
      return t('profile.divisionPopover.yardage.1')
    case 2:
      return t('profile.divisionPopover.yardage.2')
    case 3:
      return t('profile.divisionPopover.yardage.3')
    case 4:
      return t('profile.divisionPopover.yardage.4')
    case 5:
      return t('profile.divisionPopover.yardage.5')
    case 6:
      return t('profile.divisionPopover.yardage.6')
    case 7:
      return t('profile.divisionPopover.yardage.7')
    case 8:
      return t('profile.divisionPopover.yardage.8')
    case 9:
      return t('profile.divisionPopover.yardage.9')
    case 10:
    case 11:
      return t('profile.divisionPopover.yardage.10')
    default:
      return ''
  }
}

const calculateCut = record => {
  if (!record) { return 0 }
  if (record > 50) { return record - 50 }
  if (record > 45) { return record - 45 }
  if (record > 39) { return record - 39 }
  if (record > 36) { return record - 36 }
  return 0
}

const getNext = record => {
  if (!record) { return 0 }
  if (record > 50) { return 50 }
  if (record > 45) { return 45 }
  if (record > 39) { return 39 }
  if (record > 36) { return 36 }
  return 0
}

const calculatePercentage = record => {
  if (!record) { return 0 }
  if (record > 50) { return 20 }
  if (record > 45) { return 40 }
  if (record > 39) { return 60 }
  if (record > 36) { return 80 }
  return 100
}

const renderText = (
  record,
  div,
  numToCut,
  nextMilestone,
  isStudent,
  isSelf,
  isCoach,
  name,
  t
// eslint-disable-next-line max-params
) => {
  const displayName = name.charAt(0).toUpperCase() + name.slice(1)
  if (record) {
    if (record > 36) {
      const closing = isCoach
        ? t('profile.divisionPopover.closing.coach')
        : t('profile.divisionPopover.closing.keepGoing')
      if (isSelf) {
        return `${t('profile.divisionPopover.aboveTarget.self', {
          record,
          div,
          count: numToCut,
          milestone: nextMilestone,
        })} ${closing}`
      }
      return `${t('profile.divisionPopover.aboveTarget.other', {
        name: displayName,
        record,
        div,
        count: numToCut,
        milestone: nextMilestone,
      })} ${closing}`
    } else {
      return isSelf
        ? t('profile.divisionPopover.passed.self', { name: displayName, div })
        : t('profile.divisionPopover.passed.other', { name: displayName, div })
    }
  } else {
    return isCoach
      ? t('profile.divisionPopover.noRounds.coach')
      : t('profile.divisionPopover.noRounds.default')
  }
}

const DivisionPopover = props => {
  const { t } = useTranslation()
  const div =
    props.division.current_division <= 10
      ? props.division.current_division
      : 10
  const record = props.division.divisions[div - 1].nine_hole.record_score
  const numToCut = calculateCut(record)
  const nextMilestone = getNext(record)
  return (
    <div id='DivisionPopover' className='text-center'>
      <h5 className='mb-0 popover-title'>
        {t('profile.divisionPopover.levelTitle', { div })}
      </h5>
      <p>{`(${getYardage(div, t)})`}</p>
      <hr />
      <p className='mb-1'>{record ? t('profile.divisionPopover.bestScore') : ''}</p>
      {record ? <h3>{record}</h3> : null}
      <div className='progress-area'>
        <div className='current-division-progress'>
          <SmallMilestoneIcon division={div} />
        </div>
        {div < 10 ? (
          <div className='next-division-progress'>
            <SmallMilestoneIcon
              division={div + 1}
              bgColor='#fff'
              color='#c4c4c4'
            />
          </div>
        ) : (
          <div className='next-division-progress'>
            <SmallMilestoneIcon division={div} />
          </div>
        )}
      </div>
      <div className='progress-tracker-area'>
        <Progress
          value={calculatePercentage(record)}
          className='progress-container'
          barClassName={`progress-bar-${div}`}
        />
        <div className='circle-container'>
          <div
            className='fifty'
            style={{
              border: `2px solid ${getColor(div, record, 50)}`,
              color: record && record <= 50 ? '' : '#eee',
            }}
          >
            50
          </div>
          <div
            className='fortyfive'
            style={{
              border: `2px solid ${getColor(div, record, 45)}`,
              color: record && record <= 45 ? '' : '#eee',
            }}
          >
            45
          </div>
          <div
            className='thirtynine'
            style={{
              border: `2px solid ${getColor(div, record, 39)}`,
              color: record && record <= 39 ? '' : '#eee',
            }}
          >
            39
          </div>
          <div
            className='thirtysix'
            style={{
              border: `2px solid ${getColor(div, record, 36)}`,
              color: record && record <= 36 ? '' : '#eee',
            }}
          >
            36
          </div>
        </div>
      </div>
      <p className='bottom-text'>
        {renderText(
          record,
          div,
          numToCut,
          nextMilestone,
          props.isStudent,
          props.isSelf,
          props.isCoach,
          props.firstName,
          t
        )}
      </p>
    </div>
  )
}

export default DivisionPopover
